<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content">
                        <div v-loading='loading'>
                            <!-- <p>本协会网站致力于加强药师队伍建设与管理，维护药师的合法权益；增强药师的法律、道德和专业素质，提高药师的执业能力；不断改进和提高药学服务质量，保证公众用药安全、有效、经济、合理，为医药卫生事业发展和人民群众健康服务。为学员提供理论研究、对外交流、培训服务等。 -->
                            <!-- </p> -->
                            <!-- <img src="../../assets/images/note.png" width='100%' alt=""> -->
                            <img :src="content.thumb" width='100%' alt="">
                            <h1 class="title">专业科目学习与考核的流程及介绍</h1>
                            <div v-html='content.excerpt'>

                            </div>
                            <!-- <div>
                                <p>1、登录管理平台 用谷歌浏览器搜索“湖南省药师教育管理平台”（http://yaoshi.hnmpaed.com/），注册登录并完善个人信息。</p>
                                <p>2、选择药师协会 选择“培训方式”-“远程”，选择“施教机构”-“湖南省药师协会”。 </p>
                                <p>3、登录学习平台 跳转登录学习平台：“湖南省药师协会”官网/“湘药师协”APP（完成第二步，后面每次可直接登录学习平台）。</p>
                                <p>4、选课缴费 确认学习平台个人信息，与管理平台个人信息保持一致。选择课程，确认缴费。</p>
                                <p>5、在线学习 人脸识别进入，学习过程抓拍。学习记录实时上传管理平台，等待审核（7个工作日内）。</p>
                                <p>6、药师考核 学习档案审核通过后，微信搜索“湖南省药师考核”小程序，参加专业科目考核（60周岁以上药师可免考）。考核合格的7个工作日后，登录管理平台自行查询专业科目学分。</p>
                            </div> -->
                            <h1 class="title">学员须知</h1>
                            <div v-html='content.content'>

                            </div>
                            <!-- <div>
                                <p>1. 2019年湖南省执(从)业药师继续教育远程培训收费标准：</p>
                                <p>中药执业药师150元/人，</p>
                                <p>西药执业药师150元/人，</p>
                                <p>双证执业药师150元/人，</p>
                                <p>从业药师150元/人。</p>
                                <p>从业药师150元/人。</p>
                                <p>2. 支付方式：</p>
                                <p>按照系统提示，在线支付（支持微信、支付宝支付方式）。</p>
                                <p>3. 协会已收个人学员2019年度210元会费的，将于原渠道（微信或支付宝）全额退还，其中：</p>
                                <p>（1）因为支付宝原路退款期限为3个月以内，已超出3个月的将无法进行原路退回操作，因此，在2019年7月1日-2019年9月30日期间，通过支付宝支付方式缴纳210元个人会费的学员，请提供本人身份证号、支付宝账号、缴纳费用支付宝定单号、商户定单号、支付日期。
                                </p>
                                <p>（2）2019年7月1日-2019年7月31日期间，通过微信支付方式缴纳210元个人会费的学员，请提供本人身份证号、微信账号、缴纳费用微信定单号、商户定单号、支付日期。
                                </p>
                                <p>（3）以上退费事宜请联系：杨老师，19118837989（同微信号）</p>
                                <p>4.已在“湖南省药师教育管理平台”注册，且选择了“远程”培训方式-“湖南省药师协会”培训机构的个人会员，请确认缴纳150元/人的远程培训费用。</p>
                                <p>药师继续教育 学员卡优惠包 求职招聘 药师咨询</p>
                            </div> -->
                        </div>

                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../common/commonHeader.vue"; //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件
export default {
    name: 'studentsNote',
    components: {
        commonheader,
        leftMenu,
        exit
    },
    data(){
        return {
            content:'',
            loading:true
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";

        this.$store.dispatch('notes', {}).then((res) => {
            if (res.code) {
                this.content = res.data;
            }
            this.loading = false;
        }).catch(error=>{
            console.error('错误信息：', error);
            this.loading = false;
        })
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 0 86px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    .title
        margin 25px 0 19px
        font-size 20px
        color #0173FF
        // border-left 2px solid #0173FF
        padding-left 10px
        background-image $menu_border
        background-repeat no-repeat
        background-size 4px 22px
        background-position  0 4px
    p
        font-size 16px
        color #333
        line-height 30px
</style>


// WEBPACK FOOTER //
// src/components/my/studentsNote.vue